import React, { createContext, useState } from "react";
import { stateData } from "./StateData";

export const AppContext = createContext();

export function AppProvider(props) {
  const [state, setState] = useState(stateData[0]);
  return (
    <AppContext.Provider value={{ state, setState }}>
      {props.children}
    </AppContext.Provider>
  );
}
